module.exports = __webpack_public_path__ + "static/media/2x3.92acc075.svg";